import { Button, Grid, Typography, makeStyles } from "@material-ui/core";
import { is_able_to, roleName } from "../utils/roles";

import blockIcon from "../assets/icons/blockIcon.svg";
import imagePlaceHolder from "../assets/icons/imagePlaceHolder.svg";
import resetIcon from "../assets/icons/resetIcon.svg";
import { theme } from "../constants/theme";
import { useState } from "react";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { useTranslation } from 'react-i18next';

export const OrderedItemsListItem = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { item, status, rejectItemPressed, resetQuantityPressed } = props;
  const [imageLoadingError, setImageLoadingError] = useState(false);
  const itemImage =
    item.OrderLineVariantImageUrl !== undefined &&
      item.OrderLineVariantImageUrl !== ""
      ? item.OrderLineVariantImageUrl
      : item.OrderLineProductImageUrl;
  const getItemOptions = (options: any) => {
    const response: any[] = [];
    if (item.ColorNote !== "" && item.ColorNote !== null) {
      response.push(
        <div className={classes.detailContainer}>
          <Typography
            variant="caption"
            component="span"
            align="right"
            color="textSecondary"
            style={{
              color: itemNotAvailableColor(),
              display: "inline-block",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
            className={classes.fw400}
          >
{t('orderDetails.colourNote')}
          </Typography>
          <Typography
            variant="body2"
            component="span"
            align="right"
            color="textPrimary"
            style={{
              color: itemNotAvailableColor(),
              fontWeight: 600,
            }}
            className={classes.mt4}
          >
            {item.ColorNote}
          </Typography>
        </div>
      );
    }

    options.map((optionItem: any) => {
      if (optionItem.Name === "Title" || optionItem === "") {
        return <></>;
      } else {
        response.push(
          <div key={optionItem.Name} className={classes.detailContainer}>
            <Typography
              variant="caption"
              component="span"
              align="right"
              color="textSecondary"
              style={{
                color: itemNotAvailableColor(),
              }}
              className={classes.fw400}
            >
              {optionItem.Name}
            </Typography>
            <Typography
              variant="body2"
              component="span"
              align="right"
              color="textPrimary"
              style={{
                color: itemNotAvailableColor(),
                fontWeight: 600,
                marginTop: 4,
              }}
              className={classes.uCapitalize}
            >
              {optionItem.Value}
            </Typography>
          </div>
        );
      }
      return null;
    });
    return response;
  };

  const getOrderLineTitle = () => {
    return item.OrderLineVariantTitle === "Default Title" ||
      item.OrderLineVariantTitle === item.ProductTitle
      ? ""
      : item.OrderLineVariantTitle;
  };

  const cancelled = item.OrderlineCancelled !== null

  const itemNotAvailable =
    item.OrderLineQuantity === 0 || status === "RejectedDelivery"
      ? true
      : false;

  const itemNotAvailableColor = () => {
    if (status === "FailedDelivery" || itemNotAvailable) {
      return theme.palette.error.main;
    }
    if (status === "CancelledDelivery" || cancelled) {
      return theme.palette.error.main;
    }
    return undefined;
  };

  const canBeReseted = item.OrderLineOriginalQuantity > item.OrderLineQuantity;

  let textColor =
    status === "FailedDelivery"
      ? classes.notAvailableColor
      : status === "CancelledDelivery" || cancelled
        ? classes.cancelledColor
        : "";

  return (
    <Grid container item direction="row" data-testid={`ordered-item-${props.index}`}
    >
      <Grid item container alignItems="center" xs={1}>
        {imageLoadingError || itemImage === undefined ? (
          <img
            src={imagePlaceHolder}
            className={classes.itemImage}
            alt="Item"
          />
        ) : (
          <img
            src={itemImage}
            className={classes.itemImage}
            alt="Item"
            onError={(e) => {
              setImageLoadingError(true);
            }}
          />
        )}
      </Grid>
      <Grid
        item
        xs={11}
        className={classes.titleContainer}
        container
        direction="row"
        alignItems="center"
      >
        <Grid item xs={9}>
          <Typography
            variant="body1"
            component="p"
            color="textPrimary"
            className={`${textColor} ${classes.fw600} ${classes.uCapitalize}`}
          >
            {(item.ProductTitle + " " + getOrderLineTitle()).toLowerCase()}
          </Typography>
          <Typography
            variant="body2"
            component="p"
            color="textSecondary"
            style={{
              fontWeight: 400,
              color: itemNotAvailableColor(),
              paddingTop: 2,
            }}
          >
            {item.OrderLineVariantSKU}
          </Typography>
        </Grid>

        <Grid
          item
          xs={3}
          container
          justifyContent="flex-end"
          alignItems="center"
        >
          {status === "PendingDelivery" &&
            !canBeReseted &&
            roleName() !== "Admin" &&
            is_able_to("reject_orders") &&
            !cancelled ? ( // cross
            <Button
              className={classes.rejectItemButton}
              onClick={() => rejectItemPressed(item)}
              disabled={props?.loading}
            >
              <img
                src={blockIcon}
                className={classes.buttonIcon}
                alt="Reject icon"
              />
              <Typography
                variant="button"
                component="span"
                color="primary"
                className={classes.rejectItemText}
                data-automation="reject-item"
              >
{t('orderDetails.rejectItem')}
              </Typography>
            </Button>
          ) : (
            <></>
          )}

          {status === "PendingDelivery" && canBeReseted && roleName() !== "Admin" ? (
            <Button
              className={classes.resetQuantityButton}
              onClick={() => resetQuantityPressed(item)}
              disabled={props?.loading}
            >
              <img
                src={resetIcon}
                className={classes.resetIcon}
                alt="Reset icon"
              />
              <Typography
                variant="button"
                data-automation="reset-quantity"
                component="span"
                color="primary"
                className={classes.printButtonText}
              >
{t('orderDetails.resetQuantity')}
              </Typography>
            </Button>
          ) : (
            <></>
          )}

          {status === "FailedDelivery" || status === "CancelledDelivery" || cancelled ? (
            <Typography
              variant="button"
              data-automation="reset-quantity"
              component="span"
              color="primary"
              style={{ color: theme.palette.error.main }}
              className={classes.printButtonText}
            >
{(cancelled) ? t('orderDetails.cancelled') : t('orderDetails.deliveryFailed')}
            </Typography>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        container
        alignItems="flex-end"
        justifyContent="flex-end"
        className={classes.itemDetailContainer}
        style={{
          flexDirection: "row",
          justifyItems: "flex-end",
          marginTop: 15,
        }}
      >
        {getItemOptions(item.Options)}
        <div className={classes.detailContainer}>
          <Typography
            variant="caption"
            component="span"
            color="textSecondary"
            align="right"
            style={{
              color: itemNotAvailableColor(),
            }}
            className={classes.fw400}
          >
{t('orderDetails.quantity')}
          </Typography>

          <Typography
            data-testid="item-quantity"
            variant="body2"
            component="span"
            color="textPrimary"
            align="right"
            style={{
              color: itemNotAvailableColor(),
              fontWeight: 600,
            }}
            className={classes.mt4}
          >
            {roleName() === "Admin"
              ? item.OrderLineQuantity
              : itemNotAvailable
? t('orderDetails.notAvailable')
: `${item.OrderLineQuantity} ${canBeReseted ? `(${t('orderDetails.updated')})` : ""}`}
          </Typography>
        </div>
        {canBeReseted ?
          <div className={classes.detailContainer}>
            <Typography
              variant="caption"
              component="span"
              color="textSecondary"
              align="right"
              className={classes.fw400}>
{t('orderDetails.originalQuantity')}
            </Typography>

            <Typography
              variant="body2"
              component="span"
              color="textPrimary"
              align="right"
              style={{
                fontWeight: 600,
              }}
              className={classes.mt4}
            >
              {item.OrderLineOriginalQuantity} orig quantity
            </Typography>
          </div>
          : null}
        <div className={classes.detailContainer}>
          <Typography
            variant="caption"
            component="span"
            color="textSecondary"
            align="right"
            style={{
              color: itemNotAvailableColor(),
            }}
            className={classes.fw400}
          >
{t('orderDetails.pricePerUnitExcVat')}
          </Typography>

          <Typography
            data-testid="item-price-per-unit"
            variant="body2"
            component="span"
            color="textPrimary"
            align="right"
            style={{
              color: itemNotAvailableColor(),
              fontWeight: 600,
            }}
            className={classes.mt4}
          >
{t('currencySymbol')}{(item.OrderLineAmountPerUnit / 100).toFixed(2)}
          </Typography>
        </div>
        <div className={classes.detailContainer}>
          <Typography
            variant="caption"
            component="span"
            color="textSecondary"
            align="right"
            style={{
              color: itemNotAvailableColor(),
            }}
            className={classes.fw400}
          >
{t('orderDetails.subtotalExcVat')}
          </Typography>

          <Typography
            data-testid="item-subtotal"
            variant="body2"
            component="span"
            color="textPrimary"
            align="right"
            style={{
              color: itemNotAvailableColor(),
              fontWeight: 600,
            }}
            className={classes.mt4}
          >
{t('currencySymbol')}{((item.OrderLineQuantity * item.OrderLineAmountPerUnit) / 100).toFixed(2)}
          </Typography>
        </div>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  itemImage: {
    width: "56px",
    height: "56px",
    borderRadius: 8,
    objectFit: "contain",
  },
  uCapitalize: {
    textTransform: "capitalize",
  },
  itemDetailContainer: {
    flexDirection: "row",
  },
  detailContainer: {
    marginLeft: 48,
    //maxHeight: 49,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  mt4: {
    marginTop: 4,
  },
  buttonIcon: {
    width: "18px",
    height: "18px",
    cursor: "pointer",
    marginRight: 8,
  },
  resetIcon: {
    width: "18px",
    height: "18px",
    marginRight: "8px",
  },
  rejectItemButton: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: theme.palette.error[8],
    },
    "&:active": {
      backgroundColor: theme.palette.error[24],
    },
  },
  resetQuantityButton: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    borderRadius: 8,
    ...textButtonHoverAndActive
  },
  printButtonText: {
    textTransform: "none",
  },
  titleContainer: {
    paddingLeft: 16,
  },
  rejectItemText: {
    color: theme.palette.error.main,
  },
  cancelledColor: {
    color: "rgba(229, 76, 53, 1)",
    fontWeight: 600,
  },
  notAvailableColor: {
    color: theme.palette.error.main,
    fontWeight: 600
  },
  fw600: {
    fontWeight: 600,
  },
  fw400: {
    fontWeight: 400,
  },
});
